


































































































































































import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { booleanRequiredIf } from '@/validations';
import { api, MEMBER_API_SUB_URLS } from '@/api';

import {
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
} from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import {
  DebitCards,
  MemberDependentResponseModel,
  MemberPaymentMethodsResponseModel,
  SelectOption,
} from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  switchMode: boolean;
  refreshError: boolean;
  confirmBeforeClose: boolean;
  crossoverTerms: boolean;
  crossoverElectionOptions: SelectOption[];
  paymentMethods: any;
  changesMade: {
    medical: boolean,
      ptp: boolean,
      dental: boolean,
  };
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
).extend({
  name: 'ManageCrossover',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      switchMode: this.params.switchMode,
      refreshError: false,
      confirmBeforeClose: true,
      crossoverTerms: false,
      crossoverElectionOptions: [
        {
          text: this.$options.filters.t([
            'manage-crossover_label_yes',
            'global_yes',
          ]),
          value: true,
        },
        {
          text: this.$options.filters.t([
            'manage-crossover_label_no',
            'global_no',
          ]),
          value: false,
        },
      ],
      paymentMethods: {},
      changesMade: {
        medical: false,
        ptp: false,
        dental: false,
      },
    };
  },
  beforeMount() {
    this.constructShowErrorModel('paymentMethods');
    this.showErrorModel.ptpCrossoverElection = false;
    this.showErrorModel.crossoverTerms = false;
  },
  mounted() {
    this.paymentMethods = JSON.parse(
      JSON.stringify(this.paymentMethodsContent),
    );
  },
  computed: {
    // Getters
    paymentMethodsContent(): MemberPaymentMethodsResponseModel {
      return this.$store.getters.paymentMethods;
    },
    selfDependents(): MemberDependentResponseModel[] {
      return this.$store.getters.dependents.filter((dependent) => {
        return dependent.dependentType === 'Self';
      });
    },
    activeSelfCards(): DebitCards[] {
      const cardArray = [];
      this.selfDependents.forEach((dep) => {
        dep.debitcards.forEach((card) => {
          if (card.cardElection) {
            cardArray.push({
              dependentId: dep.dependentId,
              dependentType: dep.dependentType,
              firstName: dep.firstName,
              middleName: dep.middleName,
              lastName: dep.lastName,
              dateOfBirth: dep.dateOfBirth,
              ...card,
            });
          }
        });
      });
      return cardArray;
    },
    hasChanges(): boolean {
      let val = false;
      if (
        this.paymentMethods.canHaveMedicalCrossover &&
        this.changesMade.medical
      ) {
        if (
          this.paymentMethodsContent.medicalCrossoverElection !==
          this.paymentMethods.medicalCrossoverElection
        ) {
          val = true;
        }
      }
      if (this.paymentMethods.canHavePtPCrossover && this.changesMade.ptp) {
        if (
          this.paymentMethodsContent.ptPCrossoverElection !==
                // @ts-ignore
          this.ptPCrossoverElection
        ) {
          val = true;
        }
      }
      if (
        this.paymentMethods.canHaveDentalCrossover &&
        this.changesMade.dental
      ) {
        if (
          this.paymentMethodsContent.dentalCrossoverElection !==
          this.paymentMethods.dentalCrossoverElection
        ) {
          val = true;
        }
      }
      return val;
    },

    ptpCrossoverElection: {
      get() {
        if (this.paymentMethods.canHavePtPCrossover) {
          if (this.paymentMethods.medicalCrossoverElection) {
            // @ts-ignore
            return this.paymentMethods.ptPCrossoverElection;
          } else {
            return false;
          }
        }
        return false;
      },
      set(newValue) {
        this.paymentMethods.ptPCrossoverElection = newValue;
      },
    },
    ptpCrossoverDisabled(): boolean {
      return (
        !this.paymentMethods.medicalCrossoverElection ||
        this.paymentMethods.doNotAllowOptOut
      );
    },

    //      VALIDATION
    crossoverTermsErrors(): string[] {
      const formField = 'crossoverTerms';
      return this.FormValidationMixin.constructErrors(formField, [
        this. FormValidationMixin.validateField(
          formField,
          [
            'manage-crossover_form-error_terms-and-conditions_required',
            'global_form-error_terms-and-conditions_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
  },
  validations: {
    paymentMethods: {
      medicalCrossoverElection: {
        required: booleanRequiredIf(function(this: any): boolean {
          return this.paymentMethods.canHaveMedicalCrossover;
        }),
      },
      dentalCrossoverElection: {
        required: booleanRequiredIf(function(this: any): boolean {
          return this.paymentMethods.canHaveDentalCrossover;
        }),
      },
    },
    ptpCrossoverElection: {
      required: booleanRequiredIf(function(this: any): boolean {
        return (
          this.paymentMethods.canHavePtPCrossover && !this.ptpCrossoverDisabled
        );
      }),
    },
    crossoverTerms: {
      required,
    },
  },
  methods: {
    updateChangesMade(type): void {
      this.changesMade[type] = true;
      this.updateHasChanged();
    },
    tryAgain(): void {
      this.showErrorMessage = false;
      this.confirmBeforeClose = true;
    },
    submitForm(): void {
      this.isLoading = true;
      if (this.switchMode && this.activeSelfCards.length) {
        this.terminateDebitCards();
      } else {
        this.updateCrossoverElection();
      }
    },
    terminateDebitCards(): void {
      this.isLoading = true;
      const promises = [];
      this.activeSelfCards.forEach((card) => {
        promises.push(
          // REST-019
          api
            .post(
              `${MEMBER_API_SUB_URLS.debitCards}/${card.dependentId}/terminate`,
              {
                memberId: this.$store.getters.user.memberId,
                cardPackageId: `${card.cardPackageKey}`,
              },
          ),
        );
      });
      Promise.all(promises)
        .then(() => {
          this.updateCrossoverElection();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    updateCrossoverElection(): void {
      this.isLoading = true;
      const payload = {
        medicalCrossoverElection: this.paymentMethods.medicalCrossoverElection,
        ptPCrossoverElection: this.ptpCrossoverElection,
        dentalCrossoverElection: this.paymentMethods.dentalCrossoverElection,
      };
      this.$store
        .dispatch('updateCrossoverElection', payload)
        .then(() => {
          this.refreshPaymentMethods();
        })
        .catch(() => {
          this.confirmBeforeClose = false;
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshPaymentMethods(): void {
      this.$store
        .dispatch('getPaymentMethods')
        .then(() => {
          if (this.activeSelfCards.length) {
            this.refreshDependents();
          } else {
            this.confirmBeforeClose = false;
            this.showSuccessMessage = true;
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'manage-crossover_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
    refreshDependents(): void {
      this.$store
        .dispatch('getDependents')
        .then(() => {
          this.confirmBeforeClose = false;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'manage-crossover_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
